
import { z } from "zod";

export const TicketCategoryValues = ["AHJ_RELATED_DELAY", "BILL_AND_FUND", "BILLING_FINANCE", "CORPORATE_PARTNER_FOLLOW_UP", "CORPORATE_PARTNER_REQUEST", "CUSTOMER_FEEDBACK", "CUSTOMER_FOLLOW_UP", "DEFINE_SCOPE_AND_QUOTE", "ESCALATION", "FIX_FIELD_EXECUTION", "HOMEOWNER_REQUEST", "HOMEOWNER_UNRESPONSIVE", "INSPECTION_SCHEDULING_REQUEST", "INTERNAL_REQUEST", "MANAGE_ESCALATIONS_AND_REGULATORS", "NO_RESPONSE_ACTION_REQUIRED", "NON_REMI_SITE_WORK", "OTHER", "PROJECT_REQUEST", "QUOTING_REQUEST", "REFERRAL_REQUEST", "REMINDER", "REQUEST_ACTION_FROM_CONTRACTOR", "REQUEST_ACTION_FROM_CORPORATE_PARTNER", "REQUEST_ACTION_FROM_OTHER", "RESOLVE_WARRANTY_AND_DAMAGE", "SALES_FOLLOW_UP", "SCHEDULE_AND_ASSIGN_WORK", "SITE_WORK_DELAY", "SOW_REQUEST", "STATUS_UPDATE_REQUEST", "SUBCONTRACTOR_ISSUE", "TRAINING", "WARRANTY_DAMAGE", "WORK_SCHEDULING_REQUEST"] as const;
export const TicketCategorySchema = z.enum(TicketCategoryValues);
export const TicketCategory = TicketCategorySchema.enum;
export type TicketCategory = (typeof TicketCategoryValues)[number];
export const TicketCategoryDisplayNames = { "AHJ_RELATED_DELAY": "AHJ related delay",
"BILL_AND_FUND": "Bill & fund",
"BILLING_FINANCE": "Billing / finance",
"CORPORATE_PARTNER_FOLLOW_UP": "Corporate partner follow-up",
"CORPORATE_PARTNER_REQUEST": "Corporate partner request",
"CUSTOMER_FEEDBACK": "Customer feedback",
"CUSTOMER_FOLLOW_UP": "Homeowner follow-up",
"DEFINE_SCOPE_AND_QUOTE": "Define scope & quote",
"ESCALATION": "Escalation",
"FIX_FIELD_EXECUTION": "Fix field execution",
"HOMEOWNER_REQUEST": "Homeowner request",
"HOMEOWNER_UNRESPONSIVE": "Homeowner unresponsive",
"INSPECTION_SCHEDULING_REQUEST": "Inspection scheduling request",
"INTERNAL_REQUEST": "Internal request",
"MANAGE_ESCALATIONS_AND_REGULATORS": "Manage escalations & regulators",
"NO_RESPONSE_ACTION_REQUIRED": "No response/action required",
"NON_REMI_SITE_WORK": "Non-Remi site work",
"OTHER": "Other",
"PROJECT_REQUEST": "Project request",
"QUOTING_REQUEST": "Quoting request",
"REFERRAL_REQUEST": "Referral request",
"REMINDER": "Reminder",
"REQUEST_ACTION_FROM_CONTRACTOR": "Request action from contractor",
"REQUEST_ACTION_FROM_CORPORATE_PARTNER": "Request action from corporate partner",
"REQUEST_ACTION_FROM_OTHER": "Request action from other",
"RESOLVE_WARRANTY_AND_DAMAGE": "Resolve warranty & damage",
"SALES_FOLLOW_UP": "Sales follow-up",
"SCHEDULE_AND_ASSIGN_WORK": "Schedule & assign work",
"SITE_WORK_DELAY": "Site work delay",
"SOW_REQUEST": "SOW request",
"STATUS_UPDATE_REQUEST": "Status update request",
"SUBCONTRACTOR_ISSUE": "Subcontractor issue",
"TRAINING": "Training",
"WARRANTY_DAMAGE": "Warranty / damage",
"WORK_SCHEDULING_REQUEST": "Work scheduling request", } satisfies Record<TicketCategory, string>;
